import { OsfcRoles } from './UserRole';

export const UserType = {
    manager: 2,
    employee: 3,
    app_manager: 11,
};

// Keep in sync with USER_TYPES_WITH_OPERATIONAL_TERMINAL in
// backend/osfc/database/models/user/UserType.py
export const UserTypesWithOperationalTerminal = [UserType.employee, UserType.manager];

// One rule in two coordinate systems: user forms know the edited user's
// numeric type, while session permissions carry only the derived role
export const canHaveOperationalTerminal = ({ type, role }) =>
	UserTypesWithOperationalTerminal.includes(type) || OsfcRoles.includes(role);


export const UserTypeNames = {
	[UserType.manager]: "Manager",
	[UserType.employee]: "Employee",
	[UserType.app_manager]: "Management",

}